/* eslint-disable no-case-declarations */
import { HMSVirtualBackgroundTypes } from "@100mslive/hms-virtual-background";
import bvkBg from "../../images/BVK_bg.jpeg";

export function getRandomVirtualBackground() {
  const backgroundList = [
    {
      background: HMSVirtualBackgroundTypes.BLUR,
      backgroundType: HMSVirtualBackgroundTypes.BLUR,
    },
  ];

  const images = [
    bvkBg,
    "https://images.unsplash.com/photo-1631247072479-8a1d03a060e7",
    "https://images.unsplash.com/photo-1557750255-c76072a7aad1",
    "https://images.unsplash.com/photo-1480996408299-fc0e830b5db1",
    "https://images.unsplash.com/photo-1611195328596-d8dcf57f5cea",
  ].map(url => ({
    background: url,
    backgroundType: HMSVirtualBackgroundTypes.IMAGE,
  }));

  backgroundList.push(...images);

  /*
   //TODO: update with a better quality gif.
  const gifList = [
    {
      background: "https://www.100ms.live/images/vb-1.gif",
      backgroundType: HMSVirtualBackgroundTypes.GIF,
    },
  ];
  backgroundList.push(...gifList);
  */

  // const videoList = [
  //   "https://vod-progressive.akamaized.net/exp=1696805519~acl=%2Fvimeo-prod-skyfire-std-us%2F01%2F4292%2F9%2F246463976%2F890230862.mp4~hmac=f2e794285f87feea4d53a0db37fcefcb6e0817f7c59e39a4aae666f211f0ab1e/vimeo-prod-skyfire-std-us/01/4292/9/246463976/890230862.mp4",
  // ].map(url => ({
  //   background: url,
  //   backgroundType: HMSVirtualBackgroundTypes.VIDEO,
  // }));
  // backgroundList.push(...videoList);

  const randomIdx = Math.floor(Math.random() * backgroundList.length);
  const virtualBackground = backgroundList[randomIdx];
  switch (virtualBackground.backgroundType) {
    case HMSVirtualBackgroundTypes.IMAGE:
      const img = document.createElement("img");
      img.alt = "VB";
      img.src = backgroundList[randomIdx].background;
      virtualBackground.background = img;
      return virtualBackground;
    case HMSVirtualBackgroundTypes.VIDEO:
      const videoEl = document.createElement("video");
      videoEl.src = backgroundList[randomIdx].background;
      virtualBackground.background = videoEl;
      return virtualBackground;
    default:
      return virtualBackground;
  }
}
